import { useEffect, useState } from 'react'
import type { RootState } from '../store'
import { useAppSelector } from '../hooks'
import { fetchPhotoLabelEnabled } from '../../pages/photoTag/api'

/**
 * 判断当前团队是否开启了照片标签功能（灰度白名单）。
 *
 * 2026-05-29 之前从 Redux 读 KV `photo_label_enabled_group_ids_server` 字符串本地比对；
 * 现在改成调后端 `/web/workgroup/photo/label/whitelist/check` 接口，后端从
 * photo_label_whitelist 表查 + 校验登录态，返回 bool。优点：
 *   - 客户端拿不到完整名单，不泄露白名单全集
 *   - KV 名 / 数据源变更不需要前端跟着改
 *   - 后端可以叠加更复杂的判断（比如 VIP / 角色）
 *
 * 行为：
 *   - 初始 false（保守）；接口返回前不放开任何标签入口
 *   - 切团队（groupId 变）重新调；失败 / 没登录 / 不在团队都返 false
 */
export function usePhotoLabelEnabled(): boolean {
  // RTK POJO state，直接读 groupId（UUID 格式，后端按 UUID 鉴权）
  const groupID = useAppSelector(
    (state: RootState) => ((state.group as any).groupId as string) ?? ''
  )
  const [enabled, setEnabled] = useState<boolean>(false)

  useEffect(() => {
    if (!groupID) {
      setEnabled(false)
      return
    }
    let alive = true
    fetchPhotoLabelEnabled(groupID)
      .then((on) => {
        if (alive) setEnabled(on)
      })
      .catch(() => {
        if (alive) setEnabled(false)
      })
    return () => {
      alive = false
    }
  }, [groupID])

  return enabled
}
